import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar} from '@ionic/react';
import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import axiosInstance from '../services/AxiosInstance';
import './css/general.css';
import styles from './css/Cases.module.css';

interface CasesProps extends RouteComponentProps {
    // Define the props here
  }
  
  interface CasesState {
    // Define the state here
    userSubjects: UserSubject[];
    hasSubjects: boolean;
    refreshing: boolean;
  }
  
  interface UserSubjectInterface{
    id: number,
    subjectName: string,
    isFinished: boolean,
    userSubjectId: number,
    hasCases: boolean,
  }

  class UserSubject implements UserSubjectInterface {
    id: number;
    subjectName: string;
    isFinished: boolean;
    userSubjectId: number;
    hasCases: boolean;
  
    constructor(id: number, subjectName: string, isFinished: boolean, userSubjectId: number, hasCases: boolean) {
      this.id = id;
      this.subjectName = subjectName;
      this.isFinished = isFinished;
      this.userSubjectId = userSubjectId;
      this.hasCases = hasCases
    }
  
  }

  class Cases extends React.Component<CasesProps, CasesState> {
    constructor(props: CasesProps) {
      super(props);
  
      this.getData();
  
      this.state = {
      userSubjects: [
        {
          id: 0,
          subjectName: "",
          isFinished: false,
          userSubjectId: 0,
          hasCases: false,
        },
      ],
      hasSubjects: false,
        refreshing: false,
    };
    }

    _onRefresh() {
      this.setState({ refreshing: true });
      this.refreshCourses().then(() => {
        this.setState({ refreshing: false });
      });
    }
  
    async refreshCourses() {
      this.setState({
        userSubjects: [
          {
            id: 0,
            subjectName: "",
            isFinished: false,
            userSubjectId: 0,
            hasCases: false,
          },
        ],
      });
  
      this.getData();
    }
  
    async getData() {
        const token = await localStorage.getItem("token");
        var id = await localStorage.getItem("id");
        const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };

      let cases: boolean;
      let userSubjects: any[] = []
      
      
      axiosInstance
        .get("/UserSubjects/" + id, config)
        .then((resp) => {
          //console.log(resp.data)
          const subjects = resp.data
          if(subjects.length == 0){
            cases = false;
            this.alertSubjects();
          } else{
            cases = true
                //console.log(subjects);
                subjects.forEach((subject: { subject: { challenges: any[]; subjectName: string; }; id: number; isFinished: boolean; subjectId: number; })=> {
                  userSubjects.push({
                    id: subject.subjectId,
                    subjectName: subject.subject.subjectName,
                    isFinished: subject.isFinished,
                    userSubjectId: subject.id,
                  });
                });
              }
              //console.log(userSubjects)
              this.setState({hasSubjects: cases})
              this.getChallenges(userSubjects)
        })
        .catch((error) => {
          console.log(error);
        });
    }

    async getChallenges(subjects: any[]){
      const token = await localStorage.getItem("token");
      var id = await localStorage.getItem("id");
      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      for(let subject of subjects){
        //console.log("Subject:", subject)
        await axiosInstance.get("/UserChallenges/" + id + "/Subjects/" + subject.id, config)
        .then((res) => {
          //console.log(subject.subjectName, "res.data:", res.data)
          if(res.data == null || res.data.length == 0) {
            subject.hasCases = false
          } else {
            let challengeDone: boolean[] = []
            res.data.forEach((challenge: any) => {
              if (new Date(challenge.challenge.endDate) > new Date())
                challengeDone.push(challenge.isFinished)
            })
            if(challengeDone.every(finishedChallenge => finishedChallenge == true)) {
              subject.hasCases = false
            } else {
              subject.hasCases = true
            }
            //console.log("ChallengeDone:", challengeDone)
          }
          this.setState({userSubjects: subjects})
        })
      }
    }
  
    async alertSubjects() {
      alert("Geen onderwerpen beschikbaar");
      this.props.history.go(-1)
    }

    async goToCase(id: number, userSubjectId: number, name: string, completed: boolean) {
      const {history} = this.props;
      localStorage.setItem("subjectId", ""+ id);
      localStorage.setItem("userSubjectId", ""+ userSubjectId);
      localStorage.setItem("isCompleted", ""+ completed);
      localStorage.setItem("subjectName", ""+ name);
      
      history.push("/Case");
    }
  
    render(){
      let challenges: boolean[] = []
      this.state.userSubjects.forEach((subject) => {
        if(subject.isFinished || !subject.hasCases) {
          challenges.push(true)
        } else{
          challenges.push(false)
        }
      })
      let subject = this.state.userSubjects.map((subject, index) => (
        <div className={(styles.flexCol)} key={subject.id}>
          <div className={(styles.cases)} onClick={() => this.goToCase(subject.id, subject.userSubjectId, subject.subjectName, subject.isFinished)}>
              <div className={(styles.flex)}>
                  <figure  className={(styles.iconCase)}>
                      <img src={require("../assets/icons/case.png")}/>
                  </figure>
                  <p className={(styles.caseName)}>{subject.subjectName}</p>
              </div>
              {challenges[index] && (
                <p className={(styles.noCases)}>Er zijn voorlopig nog geen challenges beschikbaar</p>
              )}
              
          </div>
        </div>
      ));
      return (
        <IonPage>
        <IonHeader class='ion-no-border'>
          <IonToolbar>
          <button className="backButton" onClick={() => {this.props.history.goBack()}}>&larr;</button>
            <IonTitle>Mijn onderwerpen</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent fullscreen>
          <div className={(styles.subjects)}>
            {subject}
          </div>
        </IonContent>
      </IonPage>
    );
  }
  };

export default withRouter(Cases);
